import { useMutation, useQueryClient } from 'react-query';
import axios from 'api/axiosInstance';
import { ToastManager } from 'components/organisms/CommonUI';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { fetchPatientReviews } from 'store/middleware';
import { AIReview } from 'common/models/types';

interface RestoreResponse {
  error: number;
  data: AIReview;
  message: string;
}

export const useRestoreAiReview = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch<AppDispatch>();

  return useMutation({
    mutationFn: async (reviewId: number) => {
      const response = await axios.put<RestoreResponse>(`/api/v1/ai-reviews/${reviewId}/restore`);
      return response.data;
    },
    onSuccess: async (response: RestoreResponse) => {
      // 삭제된 AI 리뷰 목록 갱신
      queryClient.invalidateQueries({ queryKey: ['deletedAiReviews'] });
      
      // 복원된 리뷰의 환자 ID가 있으면 해당 환자의 리뷰 목록 업데이트
      if (response.data?.patientId) {
        try {
          await dispatch(fetchPatientReviews(response.data.patientId)).unwrap();
        } catch (error) {
          console.error('Failed to update patient reviews in Redux store:', error);
        }
      }
      
      ToastManager.show({
        content: '검토보고서가 복원되었습니다.',
        duration: 2000,
      });
    },
    onError: (error: any) => {
      const errorMessage = error.response?.status === 403 
        ? '복원 권한이 없습니다.' 
        : '검토보고서 복원에 실패했습니다.';
      
      ToastManager.show({
        content: errorMessage,
        duration: 3000,
      });
    },
  });
};